import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';
import { JtnUiBtnIcon } from '../index';

import styles from './jtn-ui-question.style.scss?module';

interface Events {
  onClickedQuestion: void;
}

type PositionKey = 'left' | 'right' | 'top' | 'bottom';

type Position = Record<PositionKey, string>;

type ComponentData = {
  isShowPopup: boolean;
};

const BTN_SIZE = 16;

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiQuestion',
    props: {
      popupPosition: {
        type: Object as () => Position,
        required: true as const
      }
    },
    data(): ComponentData {
      return {
        isShowPopup: false
      };
    },
    computed: {
      position() {
        let position = '';
        Object.keys(this.popupPosition).forEach((key: string) => {
          position += `${key}: ${this.popupPosition[key as PositionKey]};`;
        });

        return position;
      }
    },
    methods: {
      togglePopup(e: MouseEvent) {
        e.preventDefault();

        if (!this.isShowPopup) {
          this.$emit('clickedQuestion');
        }
        this.isShowPopup = !this.isShowPopup;
      }
    },
    render() {
      return (
        <div class={styles.question}>
          <JtnUiBtnIcon
            btnType="button-other-type-4"
            size={BTN_SIZE}
            onClick={(e: MouseEvent) => this.togglePopup(e)}
          >
            <svg width={BTN_SIZE} height={BTN_SIZE}>
              <use xlinkHref="/dist/legacy/svg-sprites/jtn-common.f7875ac1d2b1e964bfa6c21ef5757c8a.svg#jtn-common-question"></use>
            </svg>
          </JtnUiBtnIcon>
          {this.isShowPopup && (
            <div class={styles.popup} style={this.position}>
              <JtnUiBtnIcon
                class={styles.popupCloseBtn}
                btnType="button-other-type-3"
                size={BTN_SIZE}
                onClick={(e: MouseEvent) => this.togglePopup(e)}
              >
                <svg width={BTN_SIZE} height={BTN_SIZE}>
                  <use xlinkHref="/dist/legacy/svg-sprites/jtn-critical.42b7545660e4f467e75d4b37a02533e6.svg#jtn-critical-close"></use>
                </svg>
              </JtnUiBtnIcon>
              <div class={styles.popupContent}>{this.$slots.default}</div>
            </div>
          )}
        </div>
      );
    }
  });
